var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
